import 'zone.js';

import $ from 'jquery';

const jq = ['jQuery', '$'];
(window as any)[jq[0]] = $;
(window as any)[jq[1]] = $;